/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorpublish2Inputs */

const en_menueditorpublish2 = /** @type {(inputs: Menueditorpublish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

const de_menueditorpublish2 = /** @type {(inputs: Menueditorpublish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Menueditorpublish2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorpublish2 = /** @type {((inputs?: Menueditorpublish2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorpublish2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorpublish2(inputs)
	return de_menueditorpublish2(inputs)
});
export { menueditorpublish2 as "menuEditorPublish" }